	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Util.HashCalculator;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Util/HashCalculator.js
// module id = 24
// module chunks = 0